
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 47.4 131.2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.3 73.8l-.7 51c0 3.3 2.7 6 6 6s6-2.7 6-6v-41h2.3v40.8c0 3.3 2.7 6 6 6s6-2.7 6-6l-.7-51H11.3v.2z"}}),_c('path',{attrs:{"d":"M46.7 61.5c-.6-5.8-1.8-12-5.1-16.9-1.2-1.7-2.7-3.2-3.9-4.2-.9-.8-2.1-1.2-3.3-1.2H13.1c-1.2 0-2.4.4-3.3 1.2-1.2 1-2.7 2.5-3.9 4.2C2.6 49.5 1.4 55.7.8 61.5.1 69 .6 76.4 2.5 83.8c.4 1.5 1.7 2.5 3.2 2.5.4 0 .9-.1 1.3-.3 1.5-.6 2.3-2.4 1.9-4-1-4.2-1.6-8.3-1.7-12.5-.1-2.4-.1-4 .3-7.3.4-3.6 1.4-8.8 3.8-14.9 0-.1.1 0 .1 0V71.6H36.1V47.3s.1-.1.1 0c2.4 6.1 3.4 11.3 3.8 14.9.4 3.3.4 4.9.3 7.3-.1 4.2-.7 8.3-1.7 12.5-.4 1.6.4 3.4 1.9 4 .4.2.9.3 1.3.3 1.5 0 2.8-1 3.2-2.5 1.9-7.4 2.4-14.8 1.7-22.3zM23.7 17c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm5.8 13.6c-.5.3-1.2.2-1.5-.4-.1-.1-.1-.1-.1-.2l-1.2.1-1.2 2.7-2.9-1.2-.1-1.1c.1 0 .2-.1.3-.1.5-.3.7-1 .4-1.5-.3-.5-1-.7-1.5-.4s-.7 1-.4 1.5l.1.1-.8.7-3-1.3 1.3-3 1.1-.1c0 .1.1.3.2.4.3.5 1 .7 1.5.4.5-.4.7-1 .4-1.5-.3-.5-1-.7-1.5-.4 0 0-.1 0-.1.1l-.7-.9 1.3-3 2.7 1.2.8-.7c-.2-.5 0-1 .5-1.3.5-.3 1.2-.2 1.5.4.3.5.2 1.2-.4 1.5-.1 0-.1.1-.1.1l.1 1.1 2.7 1.2-1.2 2.7.7.9c.5-.2 1.1-.1 1.4.4.3.6.2 1.3-.3 1.6z"}})])
          )
        }
      }
    